import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { MARKETS, GLOBAL } from '@clearscore/config.i18n';
import { themeNames } from '@clearscore/constants.score-bands';
import Background from '@clearscore/rainbow.background';
import { selectors as dashboardSelectors } from '@clearscore/redux.dashboard';
import { selectors as marketSelectors } from '@clearscore/redux.market';

import images, { IMAGE_BLURRED, IMAGE_NORMAL } from './assets/images';
import styles from './app-background.css';

const getImageDetails = ({ market, theme, focus }) => {
    if (themeNames.includes(theme)) {
        const type = focus ? IMAGE_NORMAL : IMAGE_BLURRED;
        return {
            src: images[market][theme].mobile[type],
            dataId: `${market}-${type}-${theme}`,
            srcSet: [
                {
                    media: '(min-width: 1440px)',
                    src: images[market][theme].desktop[type],
                },
                {
                    media: '(min-width: 480px)',
                    src: images[market][theme].tablet[type],
                },
            ],
            isDefault: false,
        };
    }

    return {
        src: images[market].default,
        dataId: `${market}-default`,
        isDefault: true,
    };
};

const AppBackground = ({ overrideMarket, theme: overrideTheme, focus, transparent, hasGradient }) => {
    const storeMarket = useSelector(marketSelectors.getActiveMarket);
    const market = overrideMarket || storeMarket;
    const isActualMarket = [...MARKETS, GLOBAL].includes(market);
    const { theme: storeTheme } = useSelector(dashboardSelectors.getScores);
    const theme = overrideTheme || storeTheme;

    if (transparent || !isActualMarket) return null;

    const { src, srcSet, dataId, isDefault } = getImageDetails({
        market,
        theme,
        focus,
    });

    return (
        <span
            className={cx(styles.appBackground, {
                [styles.gradient]: hasGradient,
            })}
            data-qa="app-background"
            data-id={dataId}
        >
            <Background src={src} srcSet={srcSet} stretched={isDefault} />
        </span>
    );
};

AppBackground.propTypes = {
    overrideMarket: PropTypes.string,
    theme: PropTypes.string,
    focus: PropTypes.bool,
    transparent: PropTypes.bool,
    hasGradient: PropTypes.bool,
};

AppBackground.defaultProps = {
    overrideMarket: null,
    theme: null,
    focus: false,
    transparent: false,
    hasGradient: false,
};

export default AppBackground;
